"use client";

import * as React from "react";
import { HeroUIProvider } from "@heroui/system";
import { useRouter } from 'next/navigation'
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ThemeProviderProps } from "next-themes/dist/types";
import { SessionProvider } from "next-auth/react";

export type ProvidersProps = {
	children: React.ReactNode;
	themeProps?: ThemeProviderProps;
	session?: any;
}

export function Providers({ children, themeProps, session = null }: ProvidersProps) {
	const router = useRouter();

	return (
		<SessionProvider session={session}>
			<HeroUIProvider navigate={router.push}>
				<NextThemesProvider {...themeProps}>{children}</NextThemesProvider>
			</HeroUIProvider>
		</SessionProvider>
	);
}
